import type { SkeletonRowType } from '../Shared/TabSkeleton';
import { TabSkeleton } from '../Shared/TabSkeleton';

const BASE_PACK_ROWS: SkeletonRowType[] = [
  'avatar-row',
  'input-row',
  'input-row',
  'input-row',
  'input-row',
];
const OVERNIGHT_EXTRA_ROWS: SkeletonRowType[] = ['input-row', 'input-row'];

export const PackTabSkeleton = ({ isDaytime }: { isDaytime: boolean }) => {
  const rows: SkeletonRowType[] = isDaytime
    ? BASE_PACK_ROWS
    : [...BASE_PACK_ROWS, ...OVERNIGHT_EXTRA_ROWS];

  return <TabSkeleton count={2} rows={rows} headerButton />;
};
